/**
 * Formats a given date to a { date: 'yyyy-mm-dd', time: 'hh:mm' } object.
 */
export function formatDate(d: Date): { date: string; time: string } {
  const date = d.toLocaleDateString('sv-SE');
  const time = d.toLocaleTimeString('sv-SE').substring(0, 5);
  return { date, time };
}
